import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { IconoirInfoCircle, IconoirNavArrowRight } from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { CoaSummary, CoaSummaryProcessed } from 'app/models/coa-summary';
import { MotifProgressIndicator, MotifProgressIndicatorStep } from "@ey-xd/motif-wc-angular";

@Component({
  selector: 'app-chart-account-summary',
  standalone: true,
  imports: [CommonModule, MotifModule],
  templateUrl: './chart-account-summary.component.html',
  styleUrl: './chart-account-summary.component.scss',
})
export class ChartAccountSummaryComponent {
  private _coaSummary?: CoaSummary;
  private _coaSummaryProcessed?: CoaSummaryProcessed;

  hoverableInfo: string = `Some records may be unmapped due to one or more of the following reasons:
    • Missing account code in Trial Balance.
    • Account code not present in the latest CoA and missing account description for Level 2 and above in Trial Balance.
    • AI prediction failure.`;

  @Input()
  set coaSummary(value: CoaSummary) {
    this._coaSummary = value;
    this._coaSummaryProcessed = CoaSummaryProcessed.processCoaSummary(value);
  }

  get coaSummary(): CoaSummary | undefined {
    return this._coaSummary;
  }

  @Input()
  set coaSummaryProcessed(value: CoaSummaryProcessed) {
    this._coaSummary = undefined;
    this._coaSummaryProcessed = value;
  }

  get coaSummaryProcessed(): CoaSummaryProcessed | undefined {
    return this._coaSummaryProcessed;
  }

  IconoirInfoCircle = IconoirInfoCircle;
  IconoirNavArrowRight = IconoirNavArrowRight;

  constructor() {}

  // to format bullet points
  formatTooltipContent(value: string): string {
    if (!value) {
      return value;
    }

    const bullets = ['•'];
    let formattedValue = value.replace(/\n/g, ' \n');

    bullets.forEach((bullet: string) => {
      const regex = new RegExp(`\\s*${bullet}`, 'g');
      formattedValue = formattedValue.replace(regex, `\n${bullet}`);
    });

    return formattedValue.trim();
  }
}
